import { useFormContext } from 'react-hook-form';
import {
    FormInputText,
    useTheme,
    Box,
    Button,
    Icon,
    useAppSelector,
} from '../../../base';
import { IJobsBoardFilter, IJobsBoardFormValues } from '../../../common';
import { useTranslation } from 'react-i18next';
import { CheckboxFilter, SwitchFilter, DropdownFilter } from './filters';
import { jobsSelectors } from '../../../actions';

const BoardFilters = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { control, reset } = useFormContext();

    const filtersData = useAppSelector(jobsSelectors.getJobsBoardFilters);

    const renderFilters = (filter: IJobsBoardFilter) => {
        switch (filter.type) {
            case 'checkbox':
                return (
                    <CheckboxFilter
                        title={t(`filters.${filter.title}`)}
                        name={filter.name}
                        options={filter.options || []}
                        control={control}
                        key={filter.name}
                    />
                );
            case 'dropdown':
                return (
                    <DropdownFilter
                        name={filter.name}
                        title={t(`filters.${filter.title}`)}
                        options={filter.options || []}
                        control={control}
                        key={filter.name}
                    />
                );
            case 'boolean':
                return (
                    <SwitchFilter
                        title={t(`filters.${filter.title}`)}
                        name={filter.name}
                        control={control}
                        key={filter.name}
                    />
                );
        }
    };

    return (
        <>
            <Box sx={{ display: 'flex', gap: 2 }}>
                <FormInputText
                    name={IJobsBoardFormValues.search}
                    control={control}
                    placeholder={t('jobsBoard.search')}
                    removeBottomPadding
                    sx={{
                        backgroundColor: theme.palette.common.white,
                        borderRadius: 1,
                    }}
                    InputProps={{
                        startAdornment: (
                            <Box sx={{ paddingInlineStart: theme.spacing(1) }}>
                                <Icon
                                    name={'SearchIcon'}
                                    color={theme.palette.grey[500]}
                                />
                            </Box>
                        ),
                    }}
                />
                <Button
                    variant="text"
                    onClick={() => {
                        reset();
                    }}
                >
                    {t('jobsBoard.reset')}
                </Button>
            </Box>
            {filtersData?.map((filter) => {
                if (filter.shouldShow) {
                    return renderFilters(filter);
                }
            })}
        </>
    );
};

export default BoardFilters;
